<div class="modal-header">
  <h4 class="modal-title">Something went wrong</h4>
</div>
<div class="modal-body">
  <div class="row">
    <div class="col-12">
      <p>
        We ran into a problem. Sorry about that. Please try reloading the page.
      </p>
      <p>
        If you continue to see this message, please
        <a
          href="mailto:iqd-support@hi-level.co.uk?subject=iQD%20Pro%20Issue"
          target="_top"
          >email support</a
        >.
      </p>
      <p>
        <button
          type="button"
          class="btn btn-outline-info"
          (click)="isCollapsed = !isCollapsed"
          [attr.aria-expanded]="!isCollapsed"
          aria-controls="collapseExample"
        >
          Error details
        </button>
      </p>
      <div [ngbCollapse]="isCollapsed">
        <div class="card">
          <div class="card-block">
            {{ errorMessage }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-warning" (click)="close()">Close</button>
</div>
